import {useEffect, useState} from 'react'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {ICategoryList} from '../core/_model'
import {useQuery} from 'react-query'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import categoryListColumn from './categoryListColumn'
import toast from 'react-hot-toast'

type Props = {
  searchTerm: string
  onSelectCategory: (category: ICategoryList) => void
}

const GET_CATEGORY_LIST_URL = `${BASE_URL}/api/protect/getAllCategoryWithPage`
const GET_CATEGORY_BY_ID_URL = `${BASE_URL}/api/protect/getCateGoryById`

const CategoryListTable = ({searchTerm, onSelectCategory}: Props) => {
  const {
    pagination: {page, size, totalElement},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [categoryList, setCategoryList] = useState<ICategoryList[]>([])

  const {isLoading, data, error} = useQuery({
    queryKey: ['category', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_CATEGORY_LIST_URL, {params: {page, size}})
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
  })

  const handleSelect = async (selectType: string, id: number) => {
    toast.loading('Processing..')
    const response = await axios.get(`${GET_CATEGORY_BY_ID_URL}/${id}`)
    if (response.status === 200) {
      toast.dismiss()
      const data = await response.data
      onSelectCategory(data)
    } else {
      toast.dismiss()
      toast.error('Unknown error happened, please try again!')
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof ICategoryList)[] = ['category_name']
      const filtered = searchItems(data.list, searchTerm, keys)
      setCategoryList(filtered || [])

      updatePagination(data.pagination)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, data])

  return (
    <ListViewProvider isLoading={isLoading} data={categoryList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />

      <TableContent
        isLoading={isLoading}
        error={error as Error}
        tableData={categoryList}
        tableColumn={categoryListColumn(handleSelect)}
      >
        {isLoading && !data ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <TablePagination
            totalElement={totalElement}
            isLoading={isLoading}
            itemsPerPage={size}
            currentPage={page}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContent>
    </ListViewProvider>
  )
}

export default CategoryListTable
